import React from 'react';
import {
  MDBCarousel,
  MDBCarouselItem,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
} from 'mdb-react-ui-kit';

function Review() {
  return (
    <div>
      <section id="clients" class="clients section-bg">
        <MDBContainer className="my-5">
          <MDBCarousel showControls dark>
            <MDBCarouselItem className="active text-center">
              {/* <img
            src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(10).webp"
            alt="avatar"
            className="rounded-circle shadow-1-strong mb-4"
            style={{ width: '150px' }}
          /> */}
              <MDBRow className="d-flex justify-content-center">
                <MDBCol lg="8">
                  <div class="section-title">
                    <h2>Web Hosting Review</h2>
                  </div>

                  <h5 className="mb-3">Amit Sharma</h5>
                  <p className="text-muted fst-italic">
                    <MDBIcon fas icon="quote-left" className="pe-2" />
                    "My website loads faster, and I haven’t experienced any
                    downtime. The cPanel interface is user-friendly making
                    website management effortless, and their support team is
                    always helpful. I’m extremely satisfied with the service.
                    Highly recommended!"
                  </p>
                </MDBCol>
              </MDBRow>
              <ul className="list-unstyled d-flex justify-content-center text-warning mb-0">
                <li>
                  <MDBIcon fas icon="star" size="sm" />
                </li>
                <li>
                  <MDBIcon fas icon="star" size="sm" />
                </li>
                <li>
                  <MDBIcon fas icon="star" size="sm" />
                </li>
                <li>
                  <MDBIcon fas icon="star" size="sm" />
                </li>
                <li>
                  <MDBIcon far icon="star" size="sm" />
                </li>
              </ul>
            </MDBCarouselItem>

            <MDBCarouselItem className="text-center">
              {/* <img
            src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(32).webp"
            alt="avatar"
            className="rounded-circle shadow-1-strong mb-4"
            style={{ width: '150px' }}
          /> */}
              <MDBRow className="d-flex justify-content-center">
                <MDBCol lg="8">
                  <div class="section-title">
                    <h2>Web Hosting Review</h2>
                  </div>
                  <h5 className="mb-3">Priya Mehta</h5>
                  <p className="text-muted fst-italic">
                    <MDBIcon fas icon="quote-left" className="pe-2" />
                    "Finding a reliable yet budget-friendly hosting provider was
                    tough until I found this one. The LiteSpeed servers and NVMe
                    SSD storage make a huge difference in performance. Plus, the
                    free SSL gives me peace of mind. Amazing service!"
                  </p>
                </MDBCol>
              </MDBRow>
              <ul className="list-unstyled d-flex justify-content-center text-warning mb-0">
                <li>
                  <MDBIcon fas icon="star" size="sm" />
                </li>
                <li>
                  <MDBIcon fas icon="star" size="sm" />
                </li>
                <li>
                  <MDBIcon fas icon="star" size="sm" />
                </li>
                <li>
                  <MDBIcon fas icon="star" size="sm" />
                </li>
                <li>
                  <MDBIcon far icon="star" size="sm" />
                </li>
              </ul>
            </MDBCarouselItem>

            <MDBCarouselItem className="text-center">
              {/* <img
            src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(1).webp"
            alt="avatar"
            className="rounded-circle shadow-1-strong mb-4"
            style={{ width: '150px' }}
          /> */}
              <MDBRow className="d-flex justify-content-center">
                <MDBCol lg="8">
                  <div class="section-title">
                    <h2>McAfee Antivirus Review</h2>
                  </div>
                  <h5 className="mb-3">Tosh Narayan</h5>

                  <p className="text-muted fst-italic">
                    <MDBIcon fas icon="quote-left" className="pe-2" />
                    "McAfee has been a lifesaver for my PC! It runs smoothly in
                    the background, detects threats instantly, and doesn’t slow
                    down my system. The real-time protection and firewall keep
                    my data secure. I’m really happy with this purchase!"
                  </p>
                </MDBCol>
              </MDBRow>
              <ul className="list-unstyled d-flex justify-content-center text-warning mb-0">
                <li>
                  <MDBIcon fas icon="star" size="sm" />
                </li>
                <li>
                  <MDBIcon fas icon="star" size="sm" />
                </li>
                <li>
                  <MDBIcon fas icon="star" size="sm" />
                </li>
                <li>
                  <MDBIcon fas icon="star" size="sm" />
                </li>
                <li>
                  <MDBIcon far icon="star" size="sm" />
                </li>
              </ul>
            </MDBCarouselItem>
          </MDBCarousel>
        </MDBContainer>
      </section>
    </div>
  );
}

export default Review;
